module.exports = __webpack_public_path__ + "img/admin.1f33070.jpg";